<template>
  <div>
    <div v-if="abstract">
      <div class="row mt-4 border p-2">
        <div class="col-3 d-flex">
          <icon :icon="['fad', 'check']" class="text-success fa-10x mx-auto my-auto"/>
        </div>
        <div class="col-6">
          <div class="row">
            <div class="col text-success">
              <h5>{{_[abstract.setting_submission_id].submit_success.titel}}</h5>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <speaker :submission_id="abstract.setting_submission_id" area="submit_success"
                       textkey="intro_mail"></speaker>
              <br>
              <br>
              <strong>{{user.emailBusiness}}</strong>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col">
              <router-link :to="'/home'">
                <button class="btn btn-success">
                  <icon :icon="['fad', 'home']" class=""/>
                  {{wording[0].navigation.home}}
                </button>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-4 border p-2">
        <div class="col-3 d-flex">
          <icon :icon="['fad', 'info']" class="text-info fa-10x mx-auto my-auto"/>
        </div>
        <div class="col-6">
          <div class="row">
            <div class="col text-success">
            </div>
          </div>
          <div class="row">
            <div class="col">
              <speaker :submission_id="abstract.setting_submission_id" area="submit_success"
                       textkey="helptext"></speaker>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Loader v-else></Loader>
  </div>
</template>

<script>
  import {mapState} from 'vuex'

  export default {
    name: "SubmitSuccess",
    computed: {
      ...mapState([
        'user', 'abstract', 'wording'
      ]),
    }
  }
</script>

<style scoped>

</style>
